/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Video_TitleInputs */

const en_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & Launch Monitor`)
};

const es_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video y launch monitor`)
};

const de_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & Launch Monitor`)
};

const zh_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频与弹道监测仪`)
};

const ar_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفيديو وجهاز تحليل الضربات`)
};

const fr_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo et launch monitor`)
};

const vi_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & máy đo quỹ đạo`)
};

const sw_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video na Launch Monitor`)
};

const th_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิดีโอและลอนช์มอนิเตอร์`)
};

const bs_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video i launch monitor`)
};

const ja_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ＆ローンチモニター`)
};

const ko_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 & 론치 모니터`)
};

const pt_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo e launch monitor`)
};

const it_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video e launch monitor`)
};

const sv_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & Launch Monitor`)
};

const nl_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & launch monitor`)
};

const da_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & launch monitor`)
};

const nb_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video og launch monitor`)
};

const fi_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ja launch monitor`)
};

const pl_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wideo i launch monitor`)
};

const ru_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео и launch monitor`)
};

const tr_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ve launch monitor`)
};

const hi_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो और लॉन्च मॉनिटर`)
};

const id_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & launch monitor`)
};

const ms_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video & launch monitor`)
};

const cs_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video a launch monitor`)
};

const el_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βίντεο & launch monitor`)
};

const he_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`וידאו & Launch Monitor`)
};

const af_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video en launch monitor`)
};

const hu_lessons_format_video_title = /** @type {(inputs: Lessons_Format_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videó és launch monitor`)
};

/**
* | output |
* | --- |
* | "Video & Launch Monitor" |
*
* @param {Lessons_Format_Video_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_video_title = /** @type {((inputs?: Lessons_Format_Video_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Video_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_video_title(inputs)
	if (locale === "de") return de_lessons_format_video_title(inputs)
	if (locale === "zh") return zh_lessons_format_video_title(inputs)
	if (locale === "ar") return ar_lessons_format_video_title(inputs)
	if (locale === "fr") return fr_lessons_format_video_title(inputs)
	if (locale === "vi") return vi_lessons_format_video_title(inputs)
	if (locale === "sw") return sw_lessons_format_video_title(inputs)
	if (locale === "th") return th_lessons_format_video_title(inputs)
	if (locale === "bs") return bs_lessons_format_video_title(inputs)
	if (locale === "ja") return ja_lessons_format_video_title(inputs)
	if (locale === "ko") return ko_lessons_format_video_title(inputs)
	if (locale === "pt") return pt_lessons_format_video_title(inputs)
	if (locale === "it") return it_lessons_format_video_title(inputs)
	if (locale === "sv") return sv_lessons_format_video_title(inputs)
	if (locale === "nl") return nl_lessons_format_video_title(inputs)
	if (locale === "da") return da_lessons_format_video_title(inputs)
	if (locale === "nb") return nb_lessons_format_video_title(inputs)
	if (locale === "fi") return fi_lessons_format_video_title(inputs)
	if (locale === "pl") return pl_lessons_format_video_title(inputs)
	if (locale === "ru") return ru_lessons_format_video_title(inputs)
	if (locale === "tr") return tr_lessons_format_video_title(inputs)
	if (locale === "hi") return hi_lessons_format_video_title(inputs)
	if (locale === "id") return id_lessons_format_video_title(inputs)
	if (locale === "ms") return ms_lessons_format_video_title(inputs)
	if (locale === "cs") return cs_lessons_format_video_title(inputs)
	if (locale === "el") return el_lessons_format_video_title(inputs)
	if (locale === "he") return he_lessons_format_video_title(inputs)
	if (locale === "af") return af_lessons_format_video_title(inputs)
	if (locale === "hu") return hu_lessons_format_video_title(inputs)
	return en_lessons_format_video_title(inputs)
});